export default function authHeader() {
  const token = localStorage.getItem('token');
  if (token) {
     return { Authorization: 'Bearer ' + token }; // for Spring Boot back-end
    //return { 'x-access-token': user.token };       // for Node.js Express back-end
  } else {
    return {};
  }
}
